import { MarketCardMarketAccountButtonViewMode } from '../MarketCardMarketAccountButton';

export const MARKET_CARD_CONTROL_ROW_SLOT = {
  Preset: 'preset',
  MarketSelector: 'marketSelector',
  SubAccount: 'subAccount',
} as const;
export type MarketCardControlRowSlot = (typeof MARKET_CARD_CONTROL_ROW_SLOT)[keyof typeof MARKET_CARD_CONTROL_ROW_SLOT];

export interface MarketCardControlRowLayout {
  slots: MarketCardControlRowSlot[];
  gridTemplateColumns: string;
  marketSelectorButtonViewMode: MarketCardMarketAccountButtonViewMode;
}

export function getMarketCardControlRowLayout({
  showOrderPresets,
  showSubAccountSelector,
  showMarketSelectorButton,
}: {
  showOrderPresets: boolean;
  showSubAccountSelector: boolean;
  showMarketSelectorButton: boolean;
}): MarketCardControlRowLayout {
  const slots: MarketCardControlRowSlot[] = [];

  if (showOrderPresets) {
    slots.push(MARKET_CARD_CONTROL_ROW_SLOT.Preset);
  }

  if (showMarketSelectorButton) {
    slots.push(MARKET_CARD_CONTROL_ROW_SLOT.MarketSelector);
  }

  if (showSubAccountSelector) {
    slots.push(MARKET_CARD_CONTROL_ROW_SLOT.SubAccount);
  }

  return {
    slots,
    gridTemplateColumns: getGridTemplateColumns(slots.length),
    marketSelectorButtonViewMode:
      slots.length === 3 ? MarketCardMarketAccountButtonViewMode.Icon : MarketCardMarketAccountButtonViewMode.FullWidth,
  };
}

function getGridTemplateColumns(slotCount: number) {
  if (slotCount === 2) {
    return 'repeat(2, minmax(0, 1fr))';
  }

  if (slotCount === 3) {
    return '1fr auto 1fr';
  }

  return '1fr';
}
